// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__YIEhX","footer":"ModalInfo_footer__PRfn1"};